/**
 * Help centre v2 (CUR-2690): Curium's own help menu, replacing the Product Fruits launcher.
 *
 * The flag is evaluated per user and is off by default; the client gates the menu on it and the
 * server answers `NOT_FOUND` for the feedback mutation while it is off. The URLs are the same in
 * every environment, so they are code constants, not runtime config.
 */
export const HELP_CENTRE_V2_FLAG = 'enable-help-centre-v2';

/** The public knowledge base on the docs portal, `packages/docs-portal/knowledge-base` (opened in a new tab). */
export const KNOWLEDGE_BASE_URL = 'https://docusaurus.curium.app/knowledge-base/';

/** Curium Academy on LearnWorlds (opened in a new tab). */
export const CURIUM_ACADEMY_URL = 'https://curium.learnworlds.com';
